import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class TankRoof extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diameter: '',
      domeFactor: '',
      amount: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAmount = this.handleChange.bind(null, 'amount');
    this.handleChangeDiameter = this.handleChange.bind(null, 'diameter');
    this.handleChangeDomeFactor = this.handleChange.bind(null, 'domeFactor');
  }
  handleChange(key, value) {
    const {
      onCalc
    } = this.props;
    this.setState({
      [key]: value
    }, () => {
      const {
        diameter,
        domeFactor,
        amount
      } = this.state;
      if (diameter !== '' && domeFactor !== '' && amount !== '') {
        // Calculate the surface area
        const total = 0.8 * diameter ** 2 * domeFactor * amount;

        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const {
      diameter,
      domeFactor,
      amount
    } = this.state;
    const {
      result
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "0.8 x Diameter", /*#__PURE__*/React.createElement("sup", null, "2"), " x Dome Factor x Amount = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Diameter",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeDiameter,
      value: diameter
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Dome Factor",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeDomeFactor,
      value: domeFactor
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Amount",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAmount,
      value: amount
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
TankRoof.defaultProps = {
  onCalc: null,
  result: null
};
TankRoof.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};